'use strict';

module.exports = {
    initCarousel: function () {
            $('.slick-component .slick-inner').each(function () {
                var $this = $(this);
                if ($this.children('.slider-item').length < 2) {
                    $this.next('.slider-controls').remove();
                }

                $($this).slick({
                    appendDots: $(this).parent('.slick-component').find('.slick-nav'),
                    prevArrow: $(this).parent('.slick-component').find('.prevArrow'),
                    nextArrow: $(this).parent('.slick-component').find('.nextArrow'),
                    infinite: false,
                });
            });

            $('.stores-slick-products .slick-inner').each(function () {
                var $this = $(this);
                if ($this.children('.slider-item').length < 2) {
                    $this.next('.slider-controls').remove();
                }

                $($this).slick({
                    appendDots: $(this).parent('.slick-component').find('.slick-nav'),
                    prevArrow: $(this).parent('.slick-component').find('.prevArrow'),
                    nextArrow: $(this).parent('.slick-component').find('.nextArrow'),
                    infinite: false,
                });
            });
    }
};
